/* Sistema IVA incl./excl. — antes inline en snippets/iva-toggle-system.liquid (se cargaba dos veces). */
(function() {
    'use strict';
    
    class ModernIVASystem {
        constructor() {
            this.ivaRate = parseInt(document.getElementById('minimal-iva-system')?.dataset.ivaRate) || 21;
            this.showingWithIVA = false; // Por defecto SIN IVA
            this.storageKey = 'shopify_iva_preference';
            this.processedElements = new WeakSet();
            this.switchCounter = 0;
            
            this.init();
        }
        
        init() {
            
            this.loadUserPreference();
            this.setupExistingSwitches();
            this.findAndProcessPrices();
            this.setupObserver();
            this.setupVariantListeners(); // NUEVO: Agregar detección de variantes
        }
        
        setupExistingSwitches() {
            // Buscar todos los switches existentes en la página
            const switches = document.querySelectorAll('.iva-switch-input');
            switches.forEach(switchInput => {
                this.setupSwitch(switchInput);
            });
        }
        
        setupSwitch(switchInput) {
            // Asegurar que tenga un ID único
            if (!switchInput.id) {
                this.switchCounter++;
                switchInput.id = `iva-switch-${this.switchCounter}`;
                const label = switchInput.nextElementSibling;
                if (label && label.classList.contains('iva-switch-label')) {
                    label.setAttribute('for', switchInput.id);
                }
            }
            
            // Establecer estado inicial
            switchInput.checked = this.showingWithIVA;
            
            // Bind evento
            switchInput.addEventListener('change', (e) => {
                const newState = e.target.checked;
                if (newState !== this.showingWithIVA) {
                    this.toggle();
                }
            });
            
        }
        
        findAndProcessPrices() {
            const priceElements = document.querySelectorAll('.price__current');

            priceElements.forEach(element => {
                if (this.processedElements.has(element)) return;

                const text = element.textContent.trim();
                if (text.includes('€') && !text.includes('Agotado')) {
                    this.processPrice(element, 'current');
                }
            });

            // Precio tachado (compare-at): también debe seguir el toggle IVA
            document.querySelectorAll('.price__was').forEach(element => {
                if (this.processedElements.has(element)) return;
                const text = element.textContent.trim();
                if (text.includes('€')) {
                    this.processPrice(element, 'was');
                }
            });
        }

        processPrice(element, kind) {
            const text = element.textContent.trim();
            const price = this.extractPrice(text);

            if (price <= 0) return;

            this.processedElements.add(element);

            if (!element.dataset.originalPrice) {
                element.dataset.originalPrice = price.toString();
                element.dataset.originalText = text;
                element.dataset.priceKind = kind || 'current';
            }

            this.updatePriceElement(element);
        }
        
        extractPrice(text) {
            const cleanText = text.replace(/[^\d.,]/g, '');
            let price = cleanText;
            
            if (price.includes('.') && price.includes(',')) {
                const lastComma = price.lastIndexOf(',');
                const lastDot = price.lastIndexOf('.');
                
                if (lastComma > lastDot) {
                    price = price.replace(/\./g, '').replace(',', '.');
                }
            } else if (price.includes(',') && !price.includes('.')) {
                const parts = price.split(',');
                if (parts.length === 2 && parts[1].length <= 2) {
                    price = price.replace(',', '.');
                }
            }
            
            const numPrice = parseFloat(price);
            return isNaN(numPrice) ? 0 : numPrice;
        }
        
        updatePriceElement(element) {
            const originalPrice = parseFloat(element.dataset.originalPrice);
            
            const priceWithIVA = originalPrice;
            const priceWithoutIVA = originalPrice / (1 + this.ivaRate / 100);
            
            const mainPrice = this.showingWithIVA ? priceWithIVA : priceWithoutIVA;
            const secondaryPrice = this.showingWithIVA ? priceWithoutIVA : priceWithIVA;
            const mainLabel = this.showingWithIVA ? '(IVA incl.)' : '(IVA excl.)';
            const secondaryLabel = this.showingWithIVA ? '(IVA excl.)' : '(IVA incl.)';

            // El precio tachado (compare-at) solo cambia el número, sin etiqueta ni addon
            if ((element.dataset.priceKind || 'current') === 'was') {
                let value = mainPrice;
                // En modo SIN IVA, derivar el tachado del precio actual ya redondeado
                // (evita el céntimo de doble redondeo: 22,88/1,21=18,91 -> queremos 18,90)
                if (!this.showingWithIVA) {
                    const cur = element.closest('.price__default')?.querySelector('.price__current[data-original-price]');
                    if (cur) {
                        const curIncl = parseFloat(cur.dataset.originalPrice);
                        const curExcl = Math.round((curIncl / (1 + this.ivaRate / 100)) * 100) / 100;
                        value = curExcl * (originalPrice / curIncl);
                    }
                }
                element.textContent = `${this.formatPrice(value)}€`;
                return;
            }

            // No agregar clase de animación si estamos en cambio de variante
            const isVariantChange = element.dataset.variantChanging === 'true';
            if (!isVariantChange) {
                element.classList.add('price-switching');
            }
            
            // Usar timeout más corto si es cambio de variante
            const timeout = isVariantChange ? 0 : 100;
            
            setTimeout(() => {
                element.innerHTML = `${this.formatPrice(mainPrice)}€\n<span class="iva-main-label"> ${mainLabel}</span>`;
                this.addSecondaryPrice(element, secondaryPrice, secondaryLabel);
                element.classList.remove('price-switching');
                delete element.dataset.variantChanging;
            }, timeout);
        }
        
        addSecondaryPrice(priceElement, price, label) {
            const priceDefault = priceElement.closest('.price__default');
            if (!priceDefault) return;

            const existingSecondary = priceDefault.querySelector('.iva-price-addon');
            if (existingSecondary) {
                existingSecondary.remove();
            }

            // Precio tachado (compare-at) también en la línea secundaria, en SU modo de IVA,
            // para que el descuento se vea junto al precio con IVA y sin IVA.
            let wasHtml = '';
            const wasEl = priceDefault.querySelector('.price__was[data-original-price]');
            if (wasEl) {
                const curIncl = parseFloat(priceElement.dataset.originalPrice);
                const wasIncl = parseFloat(wasEl.dataset.originalPrice);
                let secWas;
                if (this.showingWithIVA) {
                    // línea secundaria = SIN IVA: derivar del actual redondeado (céntimo limpio)
                    const curExcl = Math.round((curIncl / (1 + this.ivaRate / 100)) * 100) / 100;
                    secWas = curExcl * (wasIncl / curIncl);
                } else {
                    // línea secundaria = CON IVA
                    secWas = wasIncl;
                }
                wasHtml = ` <s class="iva-price-addon__was">${this.formatPrice(secWas)}€</s>`;
            }

            const secondaryDiv = document.createElement('div');
            secondaryDiv.className = 'iva-price-addon';
            secondaryDiv.innerHTML = `${this.formatPrice(price)}€ ${label}${wasHtml}`;

            priceDefault.appendChild(secondaryDiv);
        }
        
        formatPrice(price) {
            if (price >= 1000) {
                return price.toLocaleString('es-ES', { 
                    minimumFractionDigits: 2, 
                    maximumFractionDigits: 2 
                });
            } else {
                return price.toFixed(2).replace('.', ',');
            }
        }
        
        toggle() {
            this.showingWithIVA = !this.showingWithIVA;
            this.saveUserPreference();
            this.updateAllSwitches();
            
            
            document.querySelectorAll('[data-original-price]').forEach(element => {
                this.updatePriceElement(element);
            });
            
            window.dispatchEvent(new CustomEvent('iva:toggled', {
                detail: { showingWithIVA: this.showingWithIVA }
            }));
        }
        
        updateAllSwitches() {
            const switches = document.querySelectorAll('.iva-switch-input');
            switches.forEach(switchInput => {
                switchInput.checked = this.showingWithIVA;
            });
        }
        
        setupObserver() {
            const observer = new MutationObserver((mutations) => {
                let shouldProcessPrices = false;
                let shouldProcessSwitches = false;
                
                mutations.forEach((mutation) => {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            const priceElements = node.querySelectorAll ? 
                                node.querySelectorAll('.price__current') : [];
                            
                            if (priceElements.length > 0 || node.matches?.('.price__current')) {
                                shouldProcessPrices = true;
                            }
                            
                            const switches = node.querySelectorAll ? 
                                node.querySelectorAll('.iva-switch-input') : [];
                            
                            if (switches.length > 0 || node.matches?.('.iva-switch-input')) {
                                shouldProcessSwitches = true;
                            }
                        }
                    });
                });
                
                if (shouldProcessPrices) {
                    setTimeout(() => this.findAndProcessPrices(), 100);
                }
                
                if (shouldProcessSwitches) {
                    setTimeout(() => this.setupExistingSwitches(), 100);
                }
            });
            
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
        
        // NUEVO MÉTODO: Detectar cambios de variante
        setupVariantListeners() {
            const handleVariantChange = () => {
                // Ocultar precio inmediatamente
                const priceContainer = document.querySelector('.product-info__price');
                const priceElement = document.querySelector('.product-info__price .price__current');
                
                if (priceContainer && priceElement) {
                    // Ocultar inmediatamente
                    priceContainer.style.opacity = '0';
                    priceElement.style.opacity = '0';
                    
                    setTimeout(() => {
                        // Marcar que es un cambio de variante
                        priceElement.dataset.variantChanging = 'true';
                        
                        // Limpiar para forzar reprocesamiento
                        this.processedElements.delete(priceElement);
                        delete priceElement.dataset.originalPrice;
                        delete priceElement.dataset.originalText;
                        
                        // Remover addon existente
                        const addon = document.querySelector('.product-info__price .iva-price-addon');
                        if (addon) addon.remove();

                        // Resetear también el precio tachado (compare-at) para reprocesarlo
                        const wasEl = document.querySelector('.product-info__price .price__was');
                        if (wasEl) {
                            this.processedElements.delete(wasEl);
                            delete wasEl.dataset.originalPrice;
                            delete wasEl.dataset.originalText;
                            delete wasEl.dataset.priceKind;
                        }

                        // Reprocesar
                        this.findAndProcessPrices();
                        
                        // Mostrar precio después de procesar
                        setTimeout(() => {
                            priceElement.style.opacity = '1';
                            priceContainer.style.opacity = '1';
                        }, 100);
                    }, 350);
                }
            };
            
            // Escuchar cambios en los radio buttons de variantes
            document.addEventListener('change', (e) => {
                if (e.target.matches('.js-option, input[name*="variant"]')) {
                    handleVariantChange();
                }
            });
            
            // También escuchar el evento variant:change de Shopify
            document.addEventListener('variant:change', handleVariantChange);
        }
        
        saveUserPreference() {
            try {
                localStorage.setItem(this.storageKey, JSON.stringify({
                    showingWithIVA: this.showingWithIVA,
                    timestamp: Date.now()
                }));
            } catch (e) {
                const expires = new Date();
                expires.setFullYear(expires.getFullYear() + 1);
                document.cookie = `${this.storageKey}=${this.showingWithIVA}; expires=${expires.toUTCString()}; path=/`;
            }
        }
        
        loadUserPreference() {
            try {
                const saved = localStorage.getItem(this.storageKey);
                if (saved) {
                    const data = JSON.parse(saved);
                    if (Date.now() - data.timestamp < 30 * 24 * 60 * 60 * 1000) {
                        this.showingWithIVA = data.showingWithIVA;
                    }
                }
            } catch (e) {
                const match = document.cookie.match(new RegExp(`${this.storageKey}=([^;]+)`));
                if (match) {
                    this.showingWithIVA = match[1] === 'true';
                }
            }
        }
    }
    
    function initIVASystem() {
        if (window.ivaSystem) return;
        
        window.ivaSystem = new ModernIVASystem();
        window.toggleIVA = () => window.ivaSystem.toggle();
    }
    
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initIVASystem);
    } else {
        initIVASystem();
    }
    
    window.addEventListener('load', initIVASystem);
    
})();
